import React, { useCallback } from 'react'
import { Box, Text } from '@usap/uicomponents'
import { useSparkChatEnabled } from '@usap/carparts/src/shared/hooks';
import { openSparkChatModal } from '@usap/carparts/src/shared/helpers';

export default function ReturnDetailsFooter({ exitReturnDetails, origin, OpenChatHandler }) {
  const isSparkChatEnabled = useSparkChatEnabled();

  const OpenChatBox = useCallback(e => {
    e.preventDefault();
    if(isSparkChatEnabled) {
      openSparkChatModal();
    } else {
      OpenChatHandler()
    }
  }, [OpenChatHandler, openSparkChatModal, isSparkChatEnabled])

  return (
    <>
      <Box margin={{ top: '16px' }} align="center">
        <Text size="small" margin={{ bottom: '20px' }}>
          Need help?
          {' '}
          {/* eslint-disable-next-line react/button-has-type */}
          <button
            onClick={OpenChatBox}
            href="#"
            rel="noreferrer"
            style={{
              color: '#05629B',
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              padding: 0,
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            { 'Chat with us' }
          </button>
        </Text>
      </Box>
      <Box margin={{ top: '16px' }} align="center">
        <Text
          size="medium"
          onClick={exitReturnDetails}
          color="#05629B"
          style={{ cursor: 'pointer' }}
        >
          &lt; Back to&nbsp;
          { origin }
        </Text>
      </Box>
    </>
  )
}
